@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <div class="container">
    <div class="hamburger"><p (click)="showNav.set(true)">&#9776;</p></div>

    <nav [class.show]="showNav()">
      <div class="bg" (click)="showNav.set(false)"></div>

      @if (showNav()) {
        <svg (click)="showNav.set(false)" class="close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#fff"></path> </g></svg>
      }

      <div class="nav-container">

        <div class="school-logo">
          <img [src]="schoolImage() !== '' ? schoolImage() : '/auth/school-admin-logo.png'" alt="school logo">
        </div>

        <h5>{{ schoolName() }}</h5>

        <ul>
          @for (r of visibleTabs(loggedUserRole ?? ''); track r.id) {

            <li (click)="showNav.set(false)">
              <a routerLinkActive="routerLinkActive" [routerLink]="'/dashboard/'+ r.route">
                <img class="filled" src="/dashboard/{{r.imgSrc}}" [alt]="r.routeName">
                <img class="unfilled" src="/dashboard/{{r.imgSrcFilled}}" [alt]="r.routeName">

                <h6>{{ r.routeName }}</h6>
              </a>
            </li>
          }
        </ul>
      </div>
    </nav>

    <main #main>
      <router-outlet></router-outlet>
    </main>
  </div>
}

